import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import CardHeader from "@material-ui/core/CardHeader";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";

import {
  MODE_SHORT_TITLES,
  PRACTICE,
  EASYPLAY,
  TUTOR,
  KARAOKE,
  MODE_URLS,
} from "../../lib/modesHelper";
import BookProvider from "../../lib/bookProvider";

const styles = (theme) => ({
  layout: {
    width: "auto",
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 800,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
});


export const ModeLinkButton = (props) => {
  const { score_id, mode, icon } = props;
  const modeTitle = MODE_SHORT_TITLES[mode];
  const modeLink = MODE_URLS[mode];

  return (
    <ListItemIcon className={"ListItemBadge Badge_" + mode}>
      <Link to={`${process.env.PUBLIC_URL}/${score_id}/${modeLink}`}>
        <Fab variant="extended">
          {icon ? icon : <i className="fa fa-music" />}
          <span className="Badgename">{modeTitle}</span>
        </Fab>
      </Link>
    </ListItemIcon>
  );
};

const ChapterScores = (props) => {
  const { scores } = props;
  if (!scores) return null;
  return Object.keys(scores).map((score_id, i) => {
    let score = scores[score_id];
    //console.log("Scores", score.title, score.easy, score.tutor, score.karaoke);
    return (
      <ListItem className="Tuneitem" key={i}>
        <ListItemText className="Tunetitle">
          <span className={"scoreTitle"}>{score.title}</span>
          {score.author ? <span>, {score.author}</span> : ""}
        </ListItemText>
        {score.exercise && (
          <ModeLinkButton score_id={score_id} mode={PRACTICE} />
        )}
        {score.easy && <ModeLinkButton score_id={score_id} mode={EASYPLAY} />}
        {score.tutor && <ModeLinkButton score_id={score_id} mode={TUTOR} />}
        {score.karaoke && <ModeLinkButton score_id={score_id} mode={KARAOKE} />}
      </ListItem>
    );
  });
};

class ScoreList extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      book: null,
    };
  }

  componentDidMount() {
    BookProvider.get()
      .then((book) => {
        this.setState({ book });
      })
      .catch((err) => {});
  }

  render() {
    const { book } = this.state;
    if (!book) {
      return <div>Caricamento in corso...</div>;
    }
    const { classes } = this.props;
    const book_type_string = book.kind === "student" ? "studente" : "docente";
    const is_book_demo = book.kind === "demo";
    const updatesPageUrl = "http://www.booktab.it";
    const is_updates_available = book.buildType === "usb" && book.kind === "teacher"
    console.log("is_updates_available",is_updates_available)
    console.log("is_updates_available",window.location.hostname)
    console.log("is_updates_available",book.kind)
    return (
      <div id="ScoreListContainer">
        <div className="HomePageHeader">
          <div className="HeaderContent" id="HeaderTitleAndButtonsContainer">
            <div id="BodyPercussionButtonContainer">
              <Button id="BodyPercussionButton" variant="contained" href="http://bodypercussion.hubscuola.it/" target="_blank">
                Body Percussion
              </Button>
            </div>
            <div id="ApplicationTitleContainer">
              {book.applicationTitle}
            </div>
            <div id="HelpButtonContainer">
            <Link
                className="HelpLink"
                to={`${process.env.PUBLIC_URL}/istruzioni-HUB-Music.pdf`}
                target={"_blank"}
              >
                <Fab>
                  <i className="fa fa-help" />
                </Fab>
              </Link>
            </div>
          </div>
          <div className="HeaderContent HVersion">
            versione {book_type_string}
          </div>
          <div className="HeaderContent BTitle">
            {book.author} - {book.title}
          </div>
          {is_book_demo && <div className={"HVersion"}>DEMO</div>}
        </div>
        <div className={classes.layout + " ScoreList sticky"}>
          <Paper className={classes.paper + " ScoreListPaper"}>
            <CardHeader
              className="ChapterShorttitle sticky"
              title={
                <List>
                  {book.chapters.map((chapter) => {
                    return (
                      <li key={chapter.shorttitle}>
                        <a id={"item_"+chapter.shorttitle} onClick={this.scrollToElement.bind(this,chapter.shorttitle)}>
                          {chapter.shorttitle}
                        </a>
                      </li>
                    );
                  })}
                </List>
              }
            />
            <List className="Tunelist">
              {book.chapters.map((chapter, i) => {
                return (
                  <div key={i}>
                    <div className="ChapterLongtitle" id={chapter.shorttitle}>
                      {chapter.longtitle}
                    </div>
                    <ChapterScores scores={chapter.scores} />
                  </div>
                );
              })}
            </List>
          </Paper>
        </div>
       
        {is_updates_available && (<div className="update-button" onClick={this.gotoUpdatePage}>
         CONTROLLA AGGIORNAMENTI
          </div>)}
        <div className="HomePageFooter HVersion">{book.copyright}</div>
      </div>
    );
  }


 scrollToElement =(el)=> {
  const element = document.getElementById(el)
  if(element){
    const t = element.offsetTop
    window.scrollTo(0,t+200)   
  }
  
};

   gotoUpdatePage = ()=>{
    const updatesPageUrl = "https://hubscuola.it/hub-music-re_1doc/updates";
    window.open(updatesPageUrl,"blank");
  };

  handleModeChange = (event) => {
    const mode = event.target.value;
    this.setState({ mode }, () => {
      localStorage.setItem("mt_mode", this.state.mode);
    });
  };
}

export default withStyles(styles)(ScoreList);
